export default "__VITE_ASSET__Bpj0S3LO__"